import { Filters } from 'shared/types/filters';

export function isSingleOfficeType(filters: Filters): boolean {
  return filters.officeType.length === 1;
}
